module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAASdJREFUOE9jZMACTl14rv3vz68ljExMf5iZmdNN9KXOoStjRBc4efbx5v8M/32QxRkZGXeYG8l6ooghc1Zdvcom94P3JzZXfBf6y+moqPgDJodi44mzj7IZGBimYNPIwPC/0MJYfgJWjSfPPwr4/49hPTaNTAxM4WbGMquwagQJnjj76D82jRbGciiuwwicYxceSzP9/f8EWfM/ZkYZKwPZpzgDB2zjuUcbGP4z+KMqYtxiZiTjx8jICHcN3MZT5x7b//v//wD2gIGIMjMyu5oaSe8BseEacfkN3SCYX8EaT5x93MXA8L8Un20wuf8MDP2WxnJFYI0nzz2++f//fzViNDIwMt6yMJJVB2s8feGx2d+//08So/HvfwYVaxO5uxjRQYxmkBoArURdD0NPzQoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/images/user.png
// module id = 0L9v
// module chunks = 4